import React from 'react';
import cn from 'classnames';
import { formatPrice } from '@benzinga/utils/numberUtils';

export const QuoteChange: React.FC<{
  absoluteChange?: number | null;
  positiveColor?: string;
  negativeColor?: string;
}> = ({ absoluteChange, negativeColor = 'text-red-500', positiveColor = 'text-green-500' }) => {
  if (!absoluteChange) return null;

  return (
    // Real-time value: SSR snapshot and live client value legitimately differ. Suppress
    // the hydration warning for this text node only (no rendering-logic change).
    <span
      className={cn('quote-change font-semibold', {
        [`${positiveColor}`]: absoluteChange > 0,
        [`${negativeColor}`]: absoluteChange < 0,
      })}
      suppressHydrationWarning
    >
      {formatPrice(absoluteChange, {
        fixedPlace: Math.abs(absoluteChange) < 0.1 ? undefined : 2,
        removeTrailingZero: true,
        showNearZero: Math.abs(absoluteChange) < 0.000001,
      })}
    </span>
  );
};
